import { createTheme } from '@mui/material/styles';
//Override MUI default theme
export const defaultTheme = createTheme({
    palette: {
        primary: {
            main: '#1E99FD',
            light: '#D4EAFC',
            dark: '#0279D9',
        },
        error: {
            main: '#E11D48',
            light: '#FDEDF0',
            dark: '#C62828',
        },
        success: {
            main: '#40DE7A',
            light: '#D1FFEE',
            dark: '#21BA59',
        },
        grey: {
            50: '#F9FAFB',
            100: '#F3F4F6',
            200: '#E5E7EB',
            300: '#D1D5DB',
            400: '#9CA3AF',
            500: '#6B7280',
            600: '#4B5563',
            700: '#374151',
            800: '#1F2937',
            900: '#111827',
        },
        warning: {
            light: '#FDF0E6',
            dark: '#E65100',
            main: '#FF983D',
        }
    },
    typography: {
        fontFamily: 'Open Sans, sans-serif',
        inputText: {
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '24px',
            fontStyle: 'normal',
        },
        // fontSize: 16,
        // h1: {
        //     fontSize: '1.5rem',
        //     fontWeight: 700,
        //     lineHeight: 1.36,
        // },
        h2: {
            fontSize: '1.25rem',
            fontWeight: 1000,
            lineHeight: 1.36,
        },
        //     h3: undefined,
        //     h4: undefined,
        h5: {
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: '24px',
            lineHeight: '133.4%',
        },
        h6: {
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '20px',
            lineHeight: '160%',
            letterSpacing: '0.15px',
        },
        //     subtitle1: {
        //         fontSize: '0.875rem',
        //         fontWeight: 600,
        //         lineHeight: 1.36,
        //         letterSpacing: '0.2px',
        //     },
        //     body1: {
        //         fontSize: '1rem',
        //         fontWeight: 400,
        //         lineHeight: 1.4,
        //         letterSpacing: '0.2px',
        //     },
        subtitle1: {
            fontSize: '16px',
            fontWeight: 700,
            lineHeight: '22px',
            letterSpacing: ' 0.15px',
        },
        subtitle2: {
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '22px',
            letterSpacing: ' 0.1px',
        },
        body1: {
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '150%',
            letterSpacing: '0.15px',
        },
        body2: {
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '150%',
            letterSpacing: '0.15px',
        },
        //     caption: undefined,
        //     caption1: {
        //         fontSize: '0.75rem',
        //         fontWeight: 400,
        //         lineHeight: 1.4,
        //         letterSpacing: '0.1px',
        //     },
        //     caption2: {
        //         fontSize: '0.75rem',
        //         fontWeight: 700,
        //         lineHeight: 1.4,
        //         letterSpacing: '0.1px',
        //     },
        button: {
            fontFamily: 'Open Sans, sans-serif',
            fontStyle: 'normal',
            letterSpacing: '0.4px',
            fontWeight: 700,
            textTransform: 'capitalize',
            borderRadius: '10px'
        },
    //     overline: undefined,
    //     linkText: {
    //         fontSize: '0.875rem',
    //         fontWeight: 400,
    //         lineHeight: 1.4,
    //         letterSpacing: '0.4px',
    //     },
    },
    shape: {
        borderRadius: 10,
    },
    components: {
        // MuiTextField: {
        //     styleOverrides: {
        //         root: {
        //             style: ({theme}) => css`
        //             '& label.Mui-focused': {
        //                 color: ${theme.palette.grey[600]};
        //             },
        //             '& .MuiInputLabel-root': {
        //                 color: ${theme.palette.grey[400]};
        //             },
        //             '& .MuiOutlinedInput-input': {
        //                 color: ${theme.palette.grey[800]};
        //             },
        //             '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
        //                 border-radius: 10px;
        //                 border-width: 1.2px;
        //             },
        //             '&:hover .MuiOutlinedInput-root, .MuiOutlinedInput-notchedOutline': {
        //                 border-color: ${theme.palette.grey[300]};
        //                 border-width: 1.2px;
        //             },
        //             '& .MuiFormHelperText-root': {
        //                 color: ${theme.palette.error.main};
        //             },
        //             '& .MuiTextField-root.Mui-error .MuiOutlinedInput-notchedOutline': {
        //                 borderColor: ${theme.palette.error.main};
        //             },
        //             `
        //         }
        //     }
        // },
        MuiAlert: {
            styleOverrides: {
                root: () => ({
                    boxShadow: 'none',
                    borderRadius: '4px',
                    padding: '14px 16px',
                }),
                standardSuccess: ({ theme }) => ({
                    background: theme.palette.success.light,
                    color: theme.palette.grey[700],
                    '& .MuiAlert-icon': {
                        color: theme.palette.success.main,
                    },
                }),
                outlinedError: ({ theme }) => ({
                    borderColor: theme.palette.error.main,
                    '& .MuiAlert-icon': {
                        color: theme.palette.error.main,
                    },
                }),
                standardError: ({ theme }) => ({
                    background: theme.palette.error.light,
                    color: theme.palette.grey[700],
                    '& .MuiAlert-icon': {
                        color: theme.palette.error.main,
                    },
                }),
                standardWarning: ({ theme }) => ({
                    background: theme.palette.warning.light,
                    color: theme.palette.grey[700],
                    '& .MuiAlert-icon': {
                        color: theme.palette.warning.dark,
                    },
                }),
                standardInfo: ({ theme }) => ({
                    background: theme.palette.primary.light,
                    color: theme.palette.grey[700],
                    '& .MuiAlert-icon': {
                        color: theme.palette.primary.main,
                    },
                }),
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: () => ({
                    '&.MuiTooltip-tooltip': {
                        '&.MuiTooltip-tooltipPlacementTop': {
                            marginBottom: '3px',
                        },
                    },
                }),
            },
        },
    },
});
